export default class CammeraConfig {
	constructor(public SelectedDevice: string = null) {}

	public static parse(o: object): CammeraConfig {
		const ret = new CammeraConfig();
		Object.assign(ret, o);
		return ret;
	}
}
